import gql from 'graphql-tag'

export default gql`
mutation editLabelAddress($labelId: String!, $addressEdit: String!, $phoneEdit: String!, $nameEdit : String!) {
  editLabelAddress(labelId: $labelId, addressEdit: $addressEdit, phoneEdit: $phoneEdit, nameEdit: $nameEdit) {
    _id
    recipient
    address
    data
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/editLabelAddress.js